import { SvgProps } from "@/utils/types";

export const EggAlt = ({
  primaryColor = "#D4DF65",
  outlineColor = "#0E5654",
  className,
}: SvgProps) => (
  <svg
    width="24"
    height="28"
    viewBox="0 0 24 28"
    fill="none"
    className={className}
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_905_955)">
      <path
        d="M21.6152 16.8136C21.5784 22.2445 17.1457 26.6243 11.708 26.5875C6.27041 26.5506 1.90413 22.118 1.94097 16.6803C1.9778 11.2427 6.44779 1.36439 11.8787 1.40118C17.3095 1.43797 21.652 11.3827 21.6152 16.8204L21.6152 16.8136Z"
        fill={primaryColor}
      />
      <path
        d="M11.6993 27.9131C5.54473 27.8714 0.57389 22.8259 0.615581 16.6714C0.635923 13.6685 1.8606 9.60513 3.73599 6.33075C6.05631 2.27482 8.95261 0.0557036 11.8879 0.0755873C14.8231 0.0954711 17.6891 2.35362 19.9542 6.44062C21.7851 9.7401 22.9546 13.8197 22.9343 16.8226C22.8926 22.9771 17.8539 27.948 11.6993 27.9063L11.6993 27.9131ZM11.8699 2.72678C7.56171 2.69759 3.29487 11.5425 3.25996 16.696C3.22816 21.3897 7.02351 25.2368 11.7172 25.2686C16.4109 25.3004 20.258 21.5051 20.2898 16.8114C20.3247 11.6578 16.1781 2.75596 11.8699 2.72678Z"
        fill={outlineColor}
      />
      <path
        d="M6.39618 19.0439C7.11335 19.0488 7.69866 18.4714 7.70352 17.7542C7.70838 17.037 7.13094 16.4517 6.41378 16.4469C5.69661 16.442 5.1113 17.0194 5.10644 17.7366C5.10158 18.4538 5.67902 19.0391 6.39618 19.0439Z"
        fill={outlineColor}
      />
      <path
        d="M6.17309 15.0181C6.33563 14.9854 6.52519 14.9596 6.73475 14.9746C7.03224 14.9901 7.28409 14.7551 7.27934 14.4575C7.27117 13.6661 7.3897 12.1451 8.14141 10.0061C8.35515 9.40564 7.53955 8.9943 7.191 9.52626C6.87655 10.0179 6.56141 10.6109 6.28607 11.3192C5.94885 12.1759 5.67136 13.2021 5.50751 14.4252C5.45765 14.7968 5.80051 15.1035 6.16632 15.0181L6.17309 15.0181Z"
        fill={outlineColor}
      />
    </g>
    <defs>
      <clipPath id="clip0_905_955">
        <rect
          width="22.3192"
          height="27.8381"
          fill="white"
          transform="translate(0.728516 -7.62939e-06) rotate(0.388124)"
        />
      </clipPath>
    </defs>
  </svg>
);
